<template>
  <div>
    <!--  -->
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="table.title"
    />
  </div>
</template>

<script>
import * as Category from "@/api/product/category.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    const _ = this;
    return {
      scenic_id: "",
      formData: {},
      formDesc: {},
      add: {
        scenic_id: {
          required: true,
          label: "所属景区",
          type: "input"
        },
        title: {
          required: true,
          label: "分类名称",
          type: "input"
        },
        sort: {
          required: true,
          label: "排序",
          default: 1,
          type: "number"
        },
        status: {
          required: true,
          label: "状态",
          type: "radio",
          default: 1,
          options: [
            {
              text: "启用",
              value: 1
            },
            {
              text: "禁用",
              value: 0
            }
          ],
          layout: 12
        }
      },
      info: {
        images: {
          label: "图集",
          type: "image-uploader",
          attrs: {
            // drag: true, // 多张
            multiple: true,
            size: 100,
            accept: "jpg,jpeg,png",
            action: "https://yxpt.xzusoft.com/api/upload",
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            responseFn(response, file) {
              if (response.code !== 200) {
                this.$message.error(response.msg);
              }
              // 根据响应结果, 设置 URL
              return response.data.url;
            },
            lazy: true
          },
          layout: 24
        },
        course: {
          label: "介绍",
          type: "textarea",
          layout: 24
        },

        prompt: {
          label: "演出时间提示",
          type: "textarea"
        },
        pre: {
          label: "预定须知",
          type: "quill-editor",
          attrs: {
            // 上传相关
            action: "https://yxpt.xzusoft.com/api/upload", // 上传地址
            // data: { token: "xxx" },
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            // 对响应结果进一步处理
            responseFn(response, file) {
              _.messageShow();

              // if (response.code !== 200) {
              //   this.$message.error(response.msg);
              // }
              // // 根据响应结果, 设置 URL
              // return response.data.url;
            },
            // 编辑器相关属性
            placeholder: "请输入..."
          }
        },
        policy: {
          label: "政策",
          type: "textarea"
        }
      },
      rules: {},
      dialogFormVisible: false,
      submitType: 1,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "门票分类",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          //  id: 1
          // sort: 1
          // status: 1
          // title: "分类010"
          {
            prop: "title",
            label: "分类名称",
            type: "input",
            hide: true
          },
          {
            prop: "sort",
            label: "排序",
            type: "number",
            hide: true
          },

          {
            layout: 12,
            prop: "status",
            label: "状态",
            type: "radio",
            show: "tag",
            default: 0,
            tagtype: [
              {
                text: "启用",
                type: "success",
                value: 1
              },
              {
                text: "禁用",
                type: "danger",
                value: 0
              }
            ],
            hide: true
          },

          {
            prop: "create_time",
            label: "创建时间",
            type: "input",
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false
          }
        ],
        btnNavLeft: [
          {
            text: "添加",
            size: "mini",
            type: "success",
            click: () => {
              this.formData = {};
              this.formDesc = this.add;
              this.submitType = 1;
              this.dialogFormVisible = true;
            }
          }
        ],
        btnList: [
          {
            name: "编辑",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.formDesc = this.add;
              this.formData = row;
              this.submitType = 2;
              this.dialogFormVisible = true;
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    messageShow() {
      this.$message.error(
        "目前《预定须知》不支持图片，如有需要请联系，系统管理员"
      );
      // Message({
      //   message: "目前《预定须知》不支持图片，如有需要请联系，系统管理员",
      //   type: "error",
      //   duration: 3 * 1000
      // });
    },
    handleSubmit(form, scenic_id) {
      console.log("提交表单", form);
      if (this.submitType === 1) {
        Category.addCategory.r(form).then(res => {
          this.chushihua("创建成功");
        });
      } else if (this.submitType === 2) {
        console.log("修改成功", form);
        Category.editCategory.r(form).then(res => {
          this.chushihua("修改成功");
        });
      }
    },
    chushihua(text) {
      if (text) this.$message.success(text);
      this.formData = {};
      this.dialogFormVisible = false;
      this.getlist();
    },
    handleSuccess() {},
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          Category.deleteCategory.r({ id: form.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      Category.getCategory.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
